import React from 'react';
import { cn } from 'utils';
import { useTimeline } from './TimelineProvider';
import { TimelineScale } from './types';

export const sliderItems: { label: string; scale: TimelineScale }[] = [
  {
    scale: 'hours',
    label: 'Hrs',
  },
  {
    scale: 'days',
    label: 'Days',
  },
  {
    scale: 'weeks',
    label: 'Wks',
  },
];

export function TimelineScaleSliderItem(props: {
  text: string;
  scale: TimelineScale;
}): React.ReactElement {
  const { scale, text } = props;
  const { changeScale, scale: selectedScale } = useTimeline();
  return (
    <button
      className={cn(
        [
          'odin-text-xs',
          'odin-flex-1',
          'odin-border-b-2',
          'odin-border-b-transparent',
        ],
        {
          'odin-border-b-odin-black': selectedScale === scale,
          'odin-text-odin-black': selectedScale === scale,
          'odin-text-slate-500': selectedScale !== scale,
        },
      )}
      onClick={() => changeScale(scale)}
    >
      {text}
    </button>
  );
}

/**
 * The interactive element for selecting the timeline scale.
 */
export function TimelineScaleSlider(): React.ReactElement {
  return (
    <div className="odin-flex odin-flex-row">
      {sliderItems.map(({ label, scale }) => (
        <TimelineScaleSliderItem key={scale} scale={scale} text={label} />
      ))}
    </div>
  );
}
